import React, { Component } from "react";
import { Card, CardDeck, Row, Col, Container,Modal,Button } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.css';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import Select from 'react-select'
import FeatherIcon from 'feather-icons-react';
import axiosConfig from '../config/axiosConfig'
  const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'black' : 'black',
        backgroundColor: state.isSelected ? '#7367f0' : 'white'
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '10px',
        borderColor: '#7367f0'

    })
}

class ReminderAlert extends Component {
  constructor(props) {
    debugger
    super(props);
    this.state={
        
        alertSMSIsChecked: false,
        alertEmailIsChecked: false,
        valueLocation: '',
        
        openSMSModel: false,
        openEmailModel: false,
        // SMSdata: [
        //     // { "MobileNo": "+923333329750"},
        //     // { "MobileNo": "+923333329751"},
        //     // { "MobileNo": "+923333329752"},
        //     // { "MobileNo": "+923333329753"},
        //     // { "MobileNo": "+923333329754"},
        //     // { "MobileNo": "+923333329755"}

        //         { value: '923333329750', label: '923333329750' },
        //         { value: '923333329751', label: '923333329751' },
        //         { value: '923333329752', label: '923333329752' },
        //         { value: '923333329753', label: '923333329753' },
        //         { value: '923333329754', label: '923333329754' },
        //         { value: '923333329755', label: '923333329755' }
        // ],
        // Emaildata: [
        //     { value: 'ishfaque.kazi@altpay.biz', label: 'ishfaque.kazi@altpay.biz' },
        //     { value: 'ibrarkazi@gmail.com', label: 'ibrarkazi@gmail.com' },
        //     { value: 'ameer.ali@altpay.biz', label: 'ameer.ali@altpay.biz' },
        //     { value: 'ijaz.maher@altpay.biz', label: 'ijaz.maher@altpay.biz' },
        //     { value: 'safee.sheikh@altpay.biz', label: 'safee.sheikh@altpay.biz' },
        //     { value: 'shariq.khan@altpay.biz', label: 'shariq.khan@altpay.biz' }
        // ],

        SMSdata: [],
        Emaildata: [],
        SelectedSMSId:[],
        SelectedEmailId:[],
        SelectedSMSText:[],
        SelectedEmailText:[],
        IsPushAlert:this.props.IsPushAlert,
        IsSMS:this.props.IsSMSChecked,
        IsEmail:this.props.IsEmailChecked,
        SmsDuplicateError:'',
        EmailDuplicateError:'',
        groupid:this.props.groupid,
        vrnId:this.props.vrnId
        

    }

    console.log("SMS",this.props.IsSMSChecked);
    console.log("Email",this.props.IsEmailChecked);
    // this.ChangeAlertPush = this.ChangeAlertPush.bind(this)
    // this.ChangeAlertSMS = this.ChangeAlertSMS.bind(this)
    // this.ChangeAlertEmail = this.ChangeAlertEmail.bind(this)
    this.showSMSModel=this.showSMSModel.bind(this);
    this.showSMSModelByButton =this.showSMSModelByButton.bind(this);
    this.closeSMSModel=this.closeSMSModel.bind(this);
    this.AddSMSModel=this.AddSMSModel.bind(this);
    this.showEmailModel=this.showEmailModel.bind(this);
    this.closeEmailModel=this.closeEmailModel.bind(this);
    this.AddEmailModel= this.AddEmailModel.bind(this);
    this.showEmailModelByButton =this.showEmailModelByButton.bind(this);
   

    this.sendSMSData = this.sendSMSData.bind(this);
    this.sendEmailData = this.sendEmailData.bind(this);

    this.OnchangeSMS=this.OnchangeSMS.bind(this);
    this.OnchangeEmail=this.OnchangeEmail.bind(this);
    this.sendPushAlertData=this.sendPushAlertData.bind(this);
    this.PushAlert=this.PushAlert.bind(this);
    this.sendPushAlertSMSData=this.sendPushAlertSMSData.bind(this);
    this.sendPushAlertEmailData=this.sendPushAlertEmailData.bind(this);
    
  }

//   sendData = () => {
//     this.props.parentCallback(this.state.SelectedSMSId);
//     } 

                                        
    sendSMSData = () => {
        debugger
        this.props.parentSMSCallback(this.state.SelectedSMSId);
        } 

    sendEmailData = () => {
        this.props.parentEmailCallback(this.state.SelectedEmailId);
        } 

    sendPushAlertSMSData = () => {
            this.props.parentPushAlertSMSCallback(this.state.IsSMS);
            } 
    
    sendPushAlertEmailData = () => {
        debugger
            this.props.parentPushAlertEmailCallback(this.state.IsEmail);
            }     

        
    

            

    sendPushAlertData = () => {
        debugger;
        this.props.parentPushAlertDataCallback(this.state.IsPushAlert);
        } 

   
  async OnchangeSMS(selectedOptions) {
   
      debugger
      let smslist = []
      {selectedOptions.map(o => {
        let sms = {
            SelectedSMSValue:  o.value,
            SelectedSMSText:  o.label
        }
        debugger
        // const originalString = sms.SelectedSMSText;
        // const substringToFind = '-';
        
        // const position = originalString.indexOf(substringToFind);
        // let extractedSubstring = "";
        // let PreextractedSubString = "";
        // if (position !== -1) {
        //    extractedSubstring = originalString.substring(position+2, position + originalString.length-1);
        //    PreextractedSubString = originalString.substring(0,position-1)
        //   console.log("Found:", extractedSubstring); 
        //   console.log("Found:",PreextractedSubString);// Output: "Found: world"
        // } else {
        //   console.log("Substring not found");
        // }
        //  const containsValue = (this.state.SMSdata) ? this.state.SMSdata.some(item => item.contactNo === extractedSubstring) : false;  
        // if(!containsValue) 
        // {
            // this.setState({SmsDuplicateError:""})
        smslist.push(sms);
        // }
        // else
        // {
           
        //    this.setState({SmsDuplicateError:"Record Already Exists in Database"})
              
           
        
            
        // }
      })}

   await this.setState(
        {
            SelectedSMSId: smslist
        }
    )
    this.sendSMSData();
 
}

async OnchangeEmail(selectedOptions) {

    debugger
    let emaillist = []
    {selectedOptions.map(o => {
      let email = {
          SelectedEmailValue:  o.value,
          SelectedEmailText : o.label
      }
      emaillist.push(email);
    })}

  await this.setState(
      {
        SelectedEmailId: emaillist
      }
  )
  this.sendEmailData();
}


showEmailModelByButton(e) {
    debugger
    if(this.state.IsEmail){
    console.log('showEmailModel');
    this.setState({ openEmailModel: true,
    IsEmail:true });
    console.log(this.state.openEmailModel);
    }
    else
    {
        this.setState({ 
            IsEmail:false
        });
     
    }


}

showSMSModelByButton(e) {
    debugger
    if(this.state.IsSMS){
        console.log('showSMSModel');
        this.setState({ 
            openSMSModel: true,
            IsSMS:true
        });
        console.log(this.state.openSMSModel);
    }
    else
     {
        this.setState({ 
            IsSMS:false
        });
     }

}


showSMSModel(e) {

    if(e.currentTarget.checked){
        console.log('showSMSModel');
        this.setState({ 
            openSMSModel: true,
            IsSMS:true
        });
        console.log(this.state.openSMSModel);
    }
    else
     {
        this.setState({ 
            IsSMS:false
        });
     }

}

closeSMSModel(e) {
    console.log('closeSMSModel');
    debugger
    // this.props.DataAddUpdate();
   
    this.setState({ openSMSModel: false });
    this.setState({SmsDuplicateError:""})
}

AddSMSModel(e){
    this.props.DataAddUpdate();
    this.setState({ openSMSModel: false });
    this.setState({SmsDuplicateError:""})
}

showEmailModel(e) {
   
    if(e.currentTarget.checked){
    console.log('showEmailModel');
    this.setState({ openEmailModel: true,
    IsEmail:true });
    console.log(this.state.openEmailModel);
    }
    else
    {
        this.setState({ 
            IsEmail:false
        });
     
    }


}

closeEmailModel(e) {
    console.log('closeEmailModel');
    debugger
    // this.props.DataAddUpdate();
    this.setState({ openEmailModel: false });
}
AddEmailModel(e) {

    this.props.DataAddUpdate();
    this.setState({ openEmailModel: false });
}

closeEmailModel_RESET(e) {
    console.log('closeEmailModel');
    this.setState({ openEmailModel: false });
    this.setState({ SelectedEmailId: [] });
}

  componentDidMount() {
      debugger;
        let token=localStorage.getItem('token');
       debugger;
        axiosConfig.defaults.headers.common['Token'] = token;
        axiosConfig.post('Portal/GetUserContactFiltered', {
            TelematicsCardVRNMappingMasterID: this.state.vrnId,
            GroupID: this.state.groupid
        }
        )
            .then(res => {
                debugger;
                for (var i = 0; i < res.data.userContact.length; i++) {

                    let textfield= res.data.userContact[i].name +' - '+ res.data.userContact[i].contactNo 
                    this.setState(prevState => ({
                        SMSdata: [...prevState.SMSdata, { value: res.data.userContact[i].id, label: textfield }]
                    }))
                }
            }
            )
            .catch(function (error) {
            }
            );
           
            
        token=localStorage.getItem('token') 
        axiosConfig.post('Portal/GetUserEmailFiltered', {
            TelematicsCardVRNMappingMasterID: this.state.vrnId,
            GroupID: this.state.groupid
        }
        )
        .then(res => {
            debugger;
                for (var i = 0; i < res.data.userEmail.length; i++) {

                    let textfield= res.data.userEmail[i].name +' - '+ res.data.userEmail[i].email 
                    this.setState(prevState => ({
                        Emaildata: [...prevState.Emaildata, { value: res.data.userEmail[i].id, label: textfield }]
                    }))
                }
        }
        )
        .catch(function (error) {
        }
        );
    }
  

   async PushAlert(e) {
        
    if(e.currentTarget.checked){
       await this.setState({ IsPushAlert: true });
    }
    else{ 
       await this.setState({ IsPushAlert: false });
    }

    this.sendPushAlertData();
       
}

componentWillReceiveProps(nextProps) {
    this.setState({data: nextProps.data})
  }


  render() {
    return (
     
        <div>
        <div className="row" style={{display:'contents'}}> 
        
        <CardDeck>
        <Card >
          <Card.Body>
              <div className="border border-secondary rounded p-3">
              Alert me via Push Notifications on Portal
                  <label className="switch ">
                  <input type="checkbox" className="warning" value={this.state.IsPushAlert} onChange={this.PushAlert} checked={this.state.IsPushAlert} />
                  <span className="slider  round" />
                  </label>
              </div>



          </Card.Body>
      </Card>
      <Card >
          <Card.Body>
              <div className="border border-secondary rounded p-3">
              Alert me via SMS
                  <label className="switch ">
                  {/* <input type="checkbox" className="warning" onChange={this.showSMSModel} value={this.state.IsSMS} checked={this.state.IsSMS}   /> */}
                  <input type="checkbox" className="warning" onChange={this.showSMSModel} value={this.state.IsSMS} checked={this.state.IsSMS}   /> 
                  {/* <a id="forgot2" data-toggle="modal" onClick={this.showModel} style={{ margin: '10px 0 0 24px', }}>Click Here To Request A Call Back</a> */}
                  <span className="slider  round" />
                  </label>
              </div>



          </Card.Body>
      </Card>
      <Card >
          <Card.Body>
              <div className="border border-secondary rounded p-3">
              Alert me via Email
                  <label className="switch ">
                  {/* <input type="checkbox" className="warning" onChange={this.showEmailModel}  value={this.state.IsEmail} checked={this.state.IsEmail} /> */}
                  <input type="checkbox" className="warning" onChange={this.showEmailModel}    value={this.state.IsEmail} checked={this.state.IsEmail} />
                  {/*  */}
                  <span className="slider round"></span>
                  </label>
              </div>



          </Card.Body>
      </Card>
      </CardDeck>
      </div> 
      {/* Your inserted code starts here */}
      <Row className="mb-0">
                <div className="col-md-6 col-6" style={{ textAlign: 'left' }}>
                    <h6 className='mb-0' style={{ fontWeight: 600 }}>SMS Details</h6>
                    <h7>Add SMS Profile</h7>
                    <a href="#" onClick={this.showSMSModelByButton}>
                        <FeatherIcon className="iconspacing pull-right" style={{ float: 'revert' }} icon="plus-square" size="20" color="green" />
                    </a>
                </div>
      
                <div className="col-md-6 col-6" style={{ textAlign: 'left' }}>
                    <h6 className='mb-0' style={{ fontWeight: 600 }}>Email Details</h6>
                    <h7>Add Email Profile</h7>
                    <a href="#" onClick={this.showEmailModelByButton}>
                        <FeatherIcon className="iconspacing pull-right" style={{ float: 'revert' }} icon="plus-square" size="20" color="green" />
                    </a>
                </div>
            </Row>
            {/* Your inserted code ends here */}
      <Modal show={this.state.openSMSModel} onHide={this.closeSMSModel} animation={true} centered style={{ zIndex: 99999 }}>
                        <Modal.Header closeButton>
                            <Modal.Title>SMS </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                                <div className="modal-body">
                                   

                                <Row>

                                    <div className="col-lg-4 col-md-12">
                                        <label>SMS : </label>
                                    </div>

                                    <div className="col-lg-8 col-md-12">
                                        <Select 
                                        options={this.state.SMSdata}
                                        styles={customStyles}
                                        isMulti
                                        onChange={this.OnchangeSMS}
                                    />
                                    </div>

                                </Row>
                                        
                                <div className="modal-footer">
                                    <div style={{color:"red"}}>{(this.state.SmsDuplicateError ? this.state.SmsDuplicateError : "")}</div>
                                    <Button variant="secondary" onClick={this.closeSMSModel}>Close</Button>
                                    <button className="btn btn-shell" onClick={this.AddSMSModel}>Add</button>
                                </div>
                                </div>
                        </Modal.Body>
                    </Modal>

        <Modal show={this.state.openEmailModel} onHide={this.closeEmailModel} animation={true} centered style={{ zIndex: 99999 }}>
            <Modal.Header closeButton>
                <Modal.Title>Email. </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                    <div className="modal-body">
                <Row>
                        <div className="col-lg-4 col-md-12">
                                <label>Email : </label>
                        </div>
                        <div className="col-lg-8 col-md-12">
                                 <Select 
                                                options={this.state.Emaildata}
                                                styles={customStyles}
                                                isMulti
                                                onChange={this.OnchangeEmail}
                                            />
                        </div>

                </Row>
                            
                    <div className="modal-footer">
                        <Button variant="secondary" onClick={this.closeEmailModel}>Close</Button>
                        <button className="btn btn-shell" onClick={this.AddEmailModel}>Add</button>
                    </div>
                    </div>
            </Modal.Body>
        </Modal>
                
      
      </div>

  
    );
   

  }

};


export default ReminderAlert;